// eslint-disable-next-line no-shadow
export enum UserAccountType {
  EMPLOYER = 'EMPLOYER',
  CANDIDATE = 'CANDIDATE',
  INVESTOR = 'INVESTOR',
  ADMIN = 'ADMIN',
}
